// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDml1F78fq_MjO0DGy5TkSt-ipzdeGAKEQ",
  authDomain: "zunayed-fahim.firebaseapp.com",
  projectId: "zunayed-fahim",
  storageBucket: "zunayed-fahim.appspot.com",
  messagingSenderId: "888720338388",
  appId: "1:888720338388:web:a2e81da1227914c2717a41",
  measurementId: "G-T3LG41BSY0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };

// const analytics = getAnalytics(app);
